<template>
  <v-menu
    top
    offset-y
    open-on-hover
    open-delay="500"
    close-delay="500"
    content-class="bra-8"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn :disabled="disabled" x-small icon v-bind="attrs" v-on="on" @click.stop>
      <v-icon small v-text="'mdi-information-outline'" />
      </v-btn>
    </template>

    <div class="bg-white justify-center px-4 py-2" @click.stop>
      <p v-text="'Estoque CD em excesso'" class="mb-2 text-center font-14" />
      <SysBotao v-text="'Ir para distribuição'" class="font-16" @click="irParaTelaDeDrp" />
    </div>
  </v-menu>
</template>

<script>
import SysBotao from "../../utils/botoes/SysBotao";

export default {
  name: "CoberturaCdEmExcesso",
  components: {
    SysBotao
  },
  props: {
    disabled: Boolean
  },
  methods: {
    irParaTelaDeDrp() {
      this.$router.push({name: 'drp'})
    }
  }
}
</script>

<style scoped>
</style>
